// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router' 
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import animated from 'animate.css/animate.css'
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
Vue.use(animated);

Vue.use(ElementUI);
Vue.config.productionTip = false

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})


// WEBPACK FOOTER //
// ./src/main.js